module.exports = __webpack_public_path__ + "static/media/loading10.8661f8fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/loading/loading10.png
// module id = 195
// module chunks = 0